import { GoogleLogin } from "@react-oauth/google";

import { authorize } from "@/common/auth";
import { SIGNUP_SECTION_ID } from "./scroll";

/**
 * The ask, at the bottom where it belongs and reachable from the header.
 *
 * The same `GoogleLogin` + `authorize` pair the collections sidebar's footer
 * uses; the provider is mounted at the router root, so it needs nothing here.
 * Without `auto_select`, though: One Tap is already prompting from `App`, and a
 * button that signs someone in the instant it renders is not a button.
 *
 * There is no separate sign-up — the first successful Google login creates the
 * account server-side — which is why one control answers both words.
 */
export default function LandingSignUp() {
  return (
    <section
      id={SIGNUP_SECTION_ID}
      className="scroll-mt-6 rounded-xl border bg-secondary px-6 py-10 text-center"
    >
      <h2
        className="text-[25px] font-semibold leading-[1.18] text-foreground"
        style={{ fontFamily: "var(--font-serif)" }}
      >
        Start your timeline.
      </h2>
      <p className="mx-auto mt-3 max-w-[46ch] text-[15px] leading-[1.6] text-ink2">
        Sign up with Google. Your space is private until you choose to make a
        collection public.
      </p>
      <div className="mt-6 flex justify-center">
        <GoogleLogin onSuccess={authorize} />
      </div>
    </section>
  );
}
